import React, {Component} from 'react'
import { VideoTemplateStyle } from './../../styles'
import Video from './Video'

export default class Videos extends Component {
  render() {
    const { title, picture, fields } = this.props
    return(
      <div className={`product-template--suggest ${VideoTemplateStyle()}`}>
        <div className="template-scroll">
          <div className={`template-right ${!picture ? 'full' : ''} template-content`}>
            <div className="flex">
              { title && <h2 className="subtitle"> {title} </h2> }

              <div className="suggest-container">
               <div className="flex">
                {
                  fields.videos.map((video, index) => (        
                    <Video {...video}  key={index} />
                  ))
                }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Videos/index.js